import React from "react";
import Cookies from "universal-cookie";
import LocalData from "../localData";
import Emitter from "../services";
import {
  fetchHeadersWithAuth,
  getCompaniesCountData,
  getCompaniesListData,
  getNewCompaniesListData,
//  preUserSignUp,
} from "../../api/routes/api.route";
import { CompanyMapper } from "../models/company.model";
import axios from "axios";
import appConfig from "../appConfig";
import Helper from "../helper/helper";

class CompanyService extends React.Component {
  static cookies = new Cookies();

  static getCompanyList() {
    if (Helper.getSessionToken()) {
      this.getUserCompaniesList();
    }
  }
  static getUserCompaniesList() {
    getCompaniesListData(Helper.getSessionToken()).then((res) => {
      if (res) {
        if (res.code === 401) {
          Helper.callLogError('401 getCompaniesListData ');
          LocalData.companies = [];
          Emitter.emit("COMPANIES_LOADED");
          return;
        }
        if (res.code) {
          LocalData.errorCompanies = true;
          LocalData.companies = [];
          // if (res.code === 409 && res.error_code === 2) {
          //   //this.callPreSignup();
          // }
          Emitter.emit("COMPANIES_LOADED");
        } else {
          LocalData.userRegistered = true;
          LocalData.errorCompanies = false;

          const currentDomain = Helper.companyDomain();
          const isDemo = Helper.isDemo();

          let companies = res?.data;
          let demoCompany = undefined;

          //If company is demo, add it manually to the list of userCompanies.
          if (isDemo) {
            demoCompany =
              {
                name: LocalData.configData?.company_name
                    ? LocalData.configData?.company_name?.charAt(0).toUpperCase() + LocalData.configData?.company_name?.slice(1)
                    : '',
                domain: LocalData.configData?.domain,
                address: LocalData.configData?.company_details?.address,
                email: LocalData.configData?.company_details?.email,
                logo_url: LocalData.configData?.company_details?.logo_url,
                phone: LocalData.configData?.company_details?.phone,
                scheduler_module: LocalData.configData?.scheduler_module,
                demo: true,
              };
            companies = [demoCompany, ...companies];
          }
          // Map the companies and reorder them if the current company exists
          const orderedCompanies = companies?.reduce((acc, company) => {
            const mappedCompany = CompanyMapper.fromCompanyDto(company);
            if (company.domain === currentDomain) {
              // Put the current company at the beginning
              return [mappedCompany, ...acc];
            } else {
              // Add other companies to the end
              return [...acc, mappedCompany];
            }
          }, []);

          LocalData.companies = orderedCompanies;
          Emitter.emit("COMPANIES_LOADED");
        }
      }
    });
  }
  static getNewCompaniesList() {
    // if (LocalData.terms_accepted) {
    getNewCompaniesListData(Helper.getSessionToken()).then((res) => {
      if (res) {
        if (res.code === 401) {
          Helper.callLogError('401 getNewCompaniesListData ');
          return;
        }
        if (res.code) {
          LocalData.errorNewCompanies = true;
          LocalData.newCompanies = [];
        } else {
          LocalData.userRegistered = true;
          LocalData.errorNewCompanies = false;
          LocalData.newCompanies = res?.data?.map((/** @type {CompanyDto} */ c) =>
            CompanyMapper.fromCompanyDto(c)
          );
        }
      }
    });
    // }
  }

  static getCompaniesCount() {
    if (LocalData.terms_accepted) {
      getCompaniesCountData(Helper.getSessionToken()).then((res) => {
        if (res) {
          if (res.http_code || res.code) {
            if (res.http_code === 401) {
              Helper.callLogError('401 getCompaniesCount');
              Helper.logoutFromLite();
              return;
            }
            if (res.code === 409 && res.error_code === 2) {
              LocalData.companiesCount = undefined;
              //this.callPreSignup();
            }
          } else {
            LocalData.companiesCount = res.data;
            Emitter.emit("COMPANIES_COUNT", res.data?.warnings);
            Emitter.emit("APPOINTMENTS_COUNT", res.data?.scheduled_appointments);
          }
        }
      });
    }
  }

  // static callPreSignup = () => {
  //   preUserSignUp(null, Helper.getSessionToken()).then((value) => {
  //     if (value) {
  //       Emitter.emit("REGISTER_STATE_CHANGED", value);
  //     }
  //   });
  // };

  /**
   * Fetches a list of companies.
   * @param {Category} [category] - An optional category object.
   * @param {string} [geoCoords] - Optional geographical coordinates.
   * @returns {Promise<Company[]>} A Promise that resolves to an array of company objects.
   */
  static fetchNewCompanies = async (category, geoCoords) => {
    let params = {};
    let response = null;
    if (category) {
      params.verticalName = category.key;
    }
    if (geoCoords) {
      params.geoCoords = geoCoords;
    }
    if (!category && LocalData.newCompanies?.length) {
      if (!geoCoords) {
        return LocalData.newCompanies;
      } else if (geoCoords && LocalData.newCompanies.some(company => company.distance)) {
        return LocalData.newCompanies;
      }
    }

    try {
      if (!Helper.isLiteVersion()) {
         response = await axios.get(
          `${appConfig.BASE_URL}/client/company/new`,
          { params, headers: fetchHeadersWithAuth(Helper.getSessionToken())},
        );
      } else {
        response = await axios.get(`${appConfig.BASE_URL}/company/v2`, {
          params,
        });
      }
      /** @type {Company[]} */
      const companies = (response?.data?.data || []).map((/** @type {CompanyDto} */ dto) =>
        CompanyMapper.fromCompanyDto(dto)
      );
      if (!category) {
        LocalData.newCompanies = companies;
      }
      return companies;
    } catch (error) {
      console.error("Error fetching companies:", error);
      return [];
    }
  };

  /**
   * Filter companies based on selected options.
   * @param {Company[]} companies - An array of company objects.
   * @param {Option[]} options - An array of selected options.
   * @returns {Company[]} - An array of filtered company objects.
   */
  static filterCompanies(companies, options) {
    return companies?.filter((company) => {
      const companyName = company?.name?.toLowerCase();
      return options?.some((option) => companyName?.includes(option?.label?.toLowerCase()));
    });
  }

  /**
   * Sets suggestions for companies.
   * @param {Company[]} companies - An array of company objects.
   * @param {Category|undefined} selectedCategory - The selected category (or undefined).
   * @returns {Option[]} An array of option objects.
   */
  static setSuggestions = (companies, selectedCategory) => {
    return companies?.map((c) => {
        return {
          value: c?.name,
          label: c?.name,
          isDisabled: c.name === selectedCategory?.name,
        };
      })
      .filter((c) => !c.isDisabled);
  };
}

export default CompanyService;
